import { writable } from 'svelte/store';

import type { Store, StoreState } from './types';

const initialValues: StoreState = {
    countUnreadMessages: 0,
};

function createStore(): Store {
    const store = writable(initialValues);
    const { subscribe, update, set } = store;

    return {
        subscribe,
        set,
        update,
        decrementCountUnreadMessages: (value: number) => {
            update(state => ({
                ...store,
                countUnreadMessages: Math.max(0, state.countUnreadMessages - value),
            }));
        },
        incrementCountUnreadMessages: () => {
            update(state => ({
                ...store,
                countUnreadMessages: state.countUnreadMessages + 1,
            }));
        },
    };
}

export const menuStore = createStore();
